import { waitForPromise } from "@ember/test-waiters";
import Swal from "sweetalert2";

let resolvePopupDestroyed: (() => void) | undefined;
let popupDestroyed: Promise<void> = Promise.resolve();

/**
 * Resolves when the popup that closes has left the DOM and given the focus
 * back to the element that had it before the popup opened.
 */
export function whenPopupDestroyed(): Promise<void> {
  return popupDestroyed;
}

/**
 * Swal removes the popup from the DOM only after its hide animation:
 * `willClose` and `didDestroy` make `settled()` wait for this removal.
 * A call that passes its own `willClose` or `didDestroy` replaces these hooks.
 */
export default Swal.mixin({
  target: ".ember-application",
  willClose() {
    popupDestroyed = waitForPromise(
      new Promise<void>(resolve => (resolvePopupDestroyed = resolve))
    );
  },
  didDestroy() {
    resolvePopupDestroyed?.();
    resolvePopupDestroyed = undefined;
  }
});
